var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 255,
    viewBox: "0 0 300 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.984 20.1328C244.015 27.8116 269.535 61.4504 269.139 94.6172C268.751 127.712 242.445 160.335 220.432 191.73C198.481 223.129 180.948 253.32 158.757 254.92C136.538 256.496 109.696 229.448 87.4853 211.507C65.2048 193.57 47.6061 184.731 32.4473 168.966C17.2884 153.2 4.63148 130.5 7.59498 110.175C10.5585 89.8499 29.1502 71.9127 48.5952 62.1263C68.1062 52.2718 88.4046 50.5721 116.864 40.5816C145.324 30.5912 181.922 12.3981 212.984 20.1328Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.278 173.629L156.709 91.0457C155.471 90.3018 150.502 87.0103 150.502 87.0103",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.799 97.5847C153.314 95.933 151.86 92.5295 151.86 92.5295C150.972 92.4735 144.789 89.194 144.789 89.194",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.02 89.498L162.244 81.4112",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94175 215.646L0 220.353L11.8618 236.391L15.5312 233.043L9.8835 218.774L4.94175 215.646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.724 201.008L96.6396 208.767L106.779 225.045L111.05 223.909L108.249 202.664L100.724 201.008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.949 91.0457C150.283 91.0457 152.985 88.9669 152.985 86.4025C152.985 83.838 150.283 81.7592 146.949 81.7592C143.616 81.7592 140.914 83.838 140.914 86.4025C140.914 88.9669 143.616 91.0457 146.949 91.0457Z",
    fill: "#D37C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4033 91.3057C63.6881 95.3051 4.01855 216.118 4.01855 216.118L10.7679 220.365L89.5101 132.507L66.4033 91.3057Z",
    fill: "#56CAD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.811 61.9903C119.362 63.3581 123.908 68.6772 125.394 69.6451C126.88 70.6129 143.92 81.5712 147.116 82.5391C150.312 83.5069 143.52 86.3865 143.52 86.3865C143.52 86.3865 121.321 81.3113 119.68 80.1834C118.04 79.0556 108.315 70.9849 108.315 68.8212C108.315 66.6576 117.811 61.9903 117.811 61.9903Z",
    fill: "#D37C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.805 51.5919C109.758 46.0528 119.432 59.1907 119.223 61.1224C119.013 63.0541 112.171 71.1568 107.834 71.1568C106.535 71.1568 101.325 55.4833 104.805 51.5919Z",
    fill: "#FCC486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6352 92.5215C64.4716 94.1212 59.429 106.919 59.429 111.319C59.429 141.314 102.803 149.097 109.033 149.097C108.133 153.284 98.5906 200.844 99.0406 201.888C99.4905 202.932 107.407 205.064 109.033 204.788C115.239 201.304 135.274 152.796 133.769 145.897C131.655 136.231 98.4704 107.959 93.676 105.144C88.8816 102.328 65.6352 92.5215 65.6352 92.5215Z",
    fill: "#74D5DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2888 39.1939C127.675 39.1939 101.81 103.896 95.9374 107.403C92.0585 109.715 68.0091 100.924 65.4335 92.1055C64.553 89.094 75.8407 39.1939 94.2888 39.1939Z",
    fill: "#FED385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.868 93.2334C145.201 93.2334 147.903 91.1545 147.903 88.5901C147.903 86.0257 145.201 83.9468 141.868 83.9468C138.535 83.9468 135.832 86.0257 135.832 88.5901C135.832 91.1545 138.535 93.2334 141.868 93.2334Z",
    fill: "#DE8E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6335 69.0692C83.715 72.3326 84.7739 87.3103 86.0889 87.7622C101.992 93.2334 129.533 90.8218 134.288 90.4938C139.044 90.1659 142.093 86.7144 141.856 85.8945C141.62 85.0747 126.662 78.7876 100.697 78.0477C100.216 75.0242 101.368 65.8856 100.181 65.0698C98.9941 64.2539 83.6335 69.0692 83.6335 69.0692Z",
    fill: "#DE8E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0516 41.9654C101.864 39.0539 104.343 65.6417 103.017 67.6014C101.69 69.5611 84.0913 72.3327 81.7949 70.6209C79.4986 68.9092 77.5786 44.1691 88.0516 41.9654Z",
    fill: "#FED892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4504 22.6604C96.8142 25.1641 92.4737 39.4978 92.7414 40.2577C93.009 41.0176 98.9826 44.369 101.275 44.0011C101.364 42.9093 102.338 37.0622 104.332 33.5467C106.325 30.0313 97.4504 22.6604 97.4504 22.6604Z",
    fill: "#D37C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.138 22.7322C115.885 15.1072 112.507 8.51096 107.593 7.99919C102.679 7.48741 98.0898 13.2538 97.3428 20.8789C96.5958 28.5039 99.9738 35.1001 104.888 35.6119C109.802 36.1237 114.391 30.3572 115.138 22.7322Z",
    fill: "#DE8E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4844 22.6604C95.4681 22.0845 93.5403 18.6931 93.5403 15.5416C93.5403 10.6103 98.3075 7.80278 101.523 6.34301C103.955 5.21918 106.023 0 111.562 0C115.98 0 116.275 4.58728 118.307 4.76325C123.575 5.21518 126.531 5.41915 126.531 9.36653C126.531 12.2661 122.923 20.1648 115.565 20.1648C115.565 18.7011 115.088 15.0656 114.3 13.3179C109.878 13.5459 106.279 19.405 100.146 19.381C98.8311 19.357 96.4844 22.6604 96.4844 22.6604Z",
    fill: "#FD8369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8002 25.1161C100.304 25.1161 101.523 23.5815 101.523 21.6886C101.523 19.7957 100.304 18.2611 98.8002 18.2611C97.2963 18.2611 96.0771 19.7957 96.0771 21.6886C96.0771 23.5815 97.2963 25.1161 98.8002 25.1161Z",
    fill: "#DE8E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.845 204.792H168.113V176.44C175.044 175.808 273.577 166.21 273.577 166.21V104.568L153.799 97.5847L168.113 176.448",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.299 220.457C181.546 220.457 184.179 217.743 184.179 214.394C184.179 211.046 181.546 208.331 178.299 208.331C175.051 208.331 172.418 211.046 172.418 214.394C172.418 217.743 175.051 220.457 178.299 220.457Z",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.15 220.457C296.397 220.457 299.03 217.743 299.03 214.394C299.03 211.046 296.397 208.331 293.15 208.331C289.902 208.331 287.269 211.046 287.269 214.394C287.269 217.743 289.902 220.457 293.15 220.457Z",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.477 123.353H273.577",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.658 140.878H273.577",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.288 93.5893L143.02 89.498",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.398 140.878C170.137 137.202 156.763 97.7487 156.763 97.7487",
    stroke: "#DFDFDF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 255,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.f0703815194b488d70fd1d5ed94a625e.svg";
export { ForwardRef as ReactComponent };